import { StyleSheet, Text, View } from "react-native";
import React from "react";

const Contacts = () => {
  return (
    <View>
      <Text>Contacts</Text>
    </View>
  );
};

export default Contacts;

const styles = StyleSheet.create({});
